"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scan = void 0;
const fs = require("fs");
const path = require("path");
const pMap = require("p-map");
const debug_1 = require("./debug");
const find_1 = require("./find");
const hosted_git_info_1 = require("hosted-git-info");
const signatures_1 = require("./signatures");
const git_1 = require("./git");
async function scan(options) {
    try {
        debug_1.debug.enabled = !!(options === null || options === void 0 ? void 0 : options.debug);
        debug_1.debug('options %o \n', options);
        if (!options.path) {
            throw 'invalid options no path provided.';
        }
        if (!fs.existsSync(options.path)) {
            throw `'${options.path}' does not exist.`;
        }
        const start = Date.now();
        const filePaths = await find_1.find(options.path);
        debug_1.debug('%d files found \n', filePaths.length);
        const allSignatures = await pMap(filePaths, signatures_1.getSignature, { concurrency: 20 });
        const filteredSignatures = allSignatures.filter((s) => {
            return s !== null;
        });
        const end = Date.now();
        const totalMilliseconds = end - start;
        const totalFileSignatures = allSignatures.length;
        const totalSecondsElapsedToGenerateFileSignatures = Math.floor(totalMilliseconds / 1000);
        debug_1.debug(`total fileSignatures: ${totalFileSignatures} \n`);
        debug_1.debug(`elapsed time in seconds to generate fileSignatures: ${totalSecondsElapsedToGenerateFileSignatures}s \n`);
        const facts = [
            { type: 'fileSignatures', data: filteredSignatures },
        ];
        const analytics = [
            {
                name: 'fileSignaturesAnalyticsContext',
                data: {
                    totalFileSignatures,
                    totalSecondsElapsedToGenerateFileSignatures,
                },
            },
        ];
        const target = await git_1.getTarget();
        debug_1.debug('target %o \n', target);
        const gitInfo = hosted_git_info_1.fromUrl(target.remoteUrl);
        const name = options.projectName || (gitInfo === null || gitInfo === void 0 ? void 0 : gitInfo.project) || path.basename(options.path);
        debug_1.debug('name %o \n', name);
        const scanResults = [
            {
                facts,
                identity: {
                    type: 'cpp',
                },
                name,
                target,
                analytics,
            },
        ];
        return {
            scanResults,
        };
    }
    catch (error) {
        throw new Error(`Could not scan C/C++ project, ${error}`);
    }
}
exports.scan = scan;
//# sourceMappingURL=scan.js.map